import { AggregateScoreState, ExceptionStatus } from "~/operations";
import { AggregateScoresNode } from "~/components/FirewatchPage";
import { ExceptionTooltipContent } from "~/components/exceptions/ExceptionTooltipContent/ExceptionTooltipContent";

type Params = {
  row: AggregateScoresNode;
};

export function useFirewatchException({ row }: Params) {
  const isPendingException = row.exception?.status === ExceptionStatus.New;
  const isRiskAccepted = row.state === AggregateScoreState.RiskAccepted;
  const isWorkaround = row.state === AggregateScoreState.Workaround;
  const isFalsePositive = row.state === AggregateScoreState.FalsePositive;
  const isDisabled = row.state === AggregateScoreState.Disabled;
  const hasException =
    isPendingException ||
    isRiskAccepted ||
    isDisabled ||
    isWorkaround ||
    isFalsePositive;

  const exceptionTooltipProps = {
    title: <ExceptionTooltipContent exception={row.exception ?? null} />,
  };

  return {
    hasException,
    isPendingException,
    isRiskAccepted,
    isDisabled,
    isWorkaround,
    isFalsePositive,
    exceptionTooltipProps,
  };
}
